import { FC } from 'react';
import { Alert, Box, Text, AlertProps, TextProps, LinkProps } from 'roo-ui/components';
import { WideLink } from 'components/Typography';

interface WarningAlertProps extends AlertProps {}

const WarningAlertBase: FC<WarningAlertProps> = ({ children, ...styleProps }) => (
  <Alert variant="error" icon={{ name: 'warning', color: 'ui.error', size: 32 }} p={2} mb={5} {...styleProps}>
    <Box ml={2}>{children}</Box>
  </Alert>
);

const Heading: FC<TextProps> = (props) => <Text as="div" fontSize="lg" fontWeight="bold" {...props} />;
const Body: FC<TextProps> = (props) => <Text as="div" fontSize="sm" color="emperor" mt={2} {...props} />;
const Link: FC<LinkProps> = (props) => <WideLink variant="primary" mt={2} {...props} />;

export const WarningAlert = Object.assign(WarningAlertBase, { Heading, Body, Link });
